<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0 m-0">
    <ul class="nav nav-tabs nav-tabs-highlight mb-0 mr-0" id="contactTabs">
      <li class="nav-item" style="border-left-width:0px !important">
        <a @click="enableView" href="#view-contact" class="nav-link" v-bind:class="{ 'active show' : viewtype != 'save' }" data-toggle="tab">
          <i class="icon-stack-check"></i>
        </a>
      </li>
      <li class="nav-item">
        <a @click="enableSave" v-bind:class="{ 'active show' : viewtype === 'save' }" href="#add-contact" class="nav-link" data-toggle="tab">
          <i class="icon-pencil7"></i>
        </a>
      </li>
    </ul>
    <div class="tab-content mb-0">
      <div v-bind:class="[{ show: viewtype === 'view' }, { active: viewtype === 'view' }]" id="view-contact" class="tab-pane fade">
        <view-contact ref="vueContactViewRef" v-bind:contactId="contactId"></view-contact>
      </div>
      <div id="add-contact" v-bind:class="[{ show: viewtype === 'save' }, { active: viewtype === 'save' }]" class="tab-pane fade">
        <add-contact ref="vueContactSaveRef" @event-refresh-contact="saveContact" v-bind:contactId="contactId"></add-contact>
      </div>
    </div>
  </div>
</template>

<script>

  import addContact from './add-contact.vue'
  import viewContact from './view-contact.vue'

  export default {
    name: "contact-container",
    components: {
      addContact,
      viewContact
    },
    props: {
      contactId: {
        required: false,
        type: Number,
        default: -1
      },
      viewtype: {
        required: false,
        type: String,
        default: 'save'
      }
    },
    data() {
      return {
      };
    },
    computed: {
    },

    methods: {
      enableView() {
        this.activateTab("view-contact");
      },
      enableSave() {
        this.activateTab("add-contact");
      },
      activateTab(id) {
        $('#contactTabs a[href="#' + id + '"]').tab('show');
      },
      saveContact() {
        this.isClosable();
      },
      isClosable() {
        if (!this.$store.isChanged()) {
          vm.$root.$emit('procedure_editor_can_close');
        }
        else {
          this.$refs.saveModal.openAndDoClosable();
        }
      }
    },
    mounted() {
      
    },
    created: function () {
      if (this.viewtype === "save") {
        this.enableSave();
      }
    },
    watch: {
      contactId: function (newVal, oldVal) {
       
        if (newVal > 0) {
          //this.viewtype = 'view';
          this.$refs.vueContactViewRef.contactId = newVal;
          this.$refs.vueContactSaveRef.contactId = newVal;
        } else {
          this.viewtype = 'save';
          this.$refs.vueContactSaveRef.restForm();
        }
      },
      viewtype: function (newVal, oldVal) {       
        //alert(newVal);
        //alert("old" + oldVal);
        //if (newVal === "save") {
        //  this.enableSave();
        //}
      }
     
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/contact/contact-container.vue